import { NavBar } from "./components/NavBar"
import { AboutSection } from "./components/AboutSection"
import { ProjectSection } from "./components/ProjectSection";
import { CaseStudy } from "./components/work/CaseStudy";
import { ArticlesSection } from "./components/ArticlesSection";
import { EmailSection } from "./components/EmailSection";
import { Footer } from "./components/Footer";
import { Homepage } from "./components/Homepage";
import { NotFound } from "./components/NotFound";
import { ScrollProgress } from "./components/ui/ScrollProgress";
import { SectionRail } from "./components/ui/SectionRail";
import { RouteCurtain } from "./components/ui/RouteCurtain";
import { Routes, Route } from "react-router-dom";
import './App.css'

function App() {
  return (
    <main className="min-h-screen flex flex-col bg-cream text-ink font-sans overflow-x-hidden selection:bg-mint selection:text-panel">
      <ScrollProgress />
      <NavBar/>
      <SectionRail />
      <div className="w-full pt-[68px]">
        <Routes>
            <Route path="/" element={<Homepage/>}/>
            <Route path="/about" element={<AboutSection/>}/>
            <Route path="/contact" element={<EmailSection/>}/>
            <Route path="/projects" element={<ProjectSection variant="spreads"/>}/>
            <Route path="/projects/:slug" element={<CaseStudy/>}/>
            <Route path="/writing" element={<ArticlesSection/>}/>
            <Route path="*" element={<NotFound/>}/>
        </Routes>
      </div>
      <Footer/>
      <RouteCurtain />
      <div className="grain" aria-hidden="true" />
    </main>
  )
}


export default App;
